import React from "react";
import styled from "styled-components";

import media from "utils/media";
import { Box, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useSelector } from "react-redux";

const Container = styled.footer`
  display: flex;
  justify-content: center;
  background-color: ${({ theme: { palette } }) => palette.grey[100]};
  padding: ${({ theme: { spacing } }) => spacing(2)}px;
`;

const Inner = styled.div`
  max-width: 1200px;
  width: 100%;
`;

const Navigation = styled.nav`
  display: flex;
  ${media.sp`
    flex-wrap: wrap;
  `}
`;

const AllRightsReserved = styled.div`
  font-size: 1.2rem;
  color: ${({ theme: { palette } }) => palette.grey[500]};
  text-align: center;
`;

const StyledLink = styled.a`
  color: ${({ theme: { palette } }) => palette.grey[500]};
  font-size: 1.2rem;
`;

const Footer = () => {
  // 未払い催促バナーは Redux の companyGroup を直接参照する。
  // (旧実装は clientMaster 限定で別 API 取得していたため、 notelMaster 等で表示されなかった。
  //  一律表示バグ対策は「isMonthlyPaid (=請求書 billing モード) かつ invoiceUrl (=未払い URL あり)」
  //  の両条件で担保され、 invoiceUrl が無いグループには出ないので Redux 直読みで安全。)
  const companyGroup = useSelector(
    (state) => state.account?.staff?.company?.companyGroup
  );

  return (
    <Container>
      <Inner>
        {/* 支払い期日警告を削除 - 銀行振込廃止によりStripe決済のみに統一 */}
        {companyGroup?.isMonthlyPaid && companyGroup?.invoiceUrl ? (
          <Box display="flex" justifyContent={"center"} marginTop={2}>
            <Alert severity="error">
              <Box display={"flex"} flexDirection={"column"}>
                <Typography>
                  お支払いが済んでいない請求書がございます。下記よりアクセスしてお支払いをお願いいたします。
                </Typography>
                <a
                  href={companyGroup.invoiceUrl}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  {companyGroup.invoiceUrl}
                </a>
                <Typography style={{ fontSize: "12px" }}>
                  ※尚、お支払いより1日以内の場合は反映されない場合がございます。
                </Typography>
                <Typography style={{ fontSize: "12px" }}>
                  URLにアクセスして請求書が支払い済みの場合、こちらはご放念ください。
                </Typography>
              </Box>
            </Alert>
          </Box>
        ) : (
          <></>
        )}
        <Navigation>
          <section></section>
        </Navigation>
        <Box display="flex" justifyContent={"center"} style={{ gap: 16 }}>
          <StyledLink href={"/special_commercail_code.pdf"}>
            特定商取引法に基づく表記
          </StyledLink>
          <StyledLink
            href="https://tasteck.tech"
            target="_blank"
            rel="noopener noreferrer"
          >
            公式サイト
          </StyledLink>
          <StyledLink
            href="https://tasteck.tech/blog"
            target="_blank"
            rel="noopener noreferrer"
          >
            ブログ
          </StyledLink>
        </Box>
        <AllRightsReserved>©TasTeck All Rights Reserved.</AllRightsReserved>
      </Inner>
    </Container>
  );
};

export default Footer;
